export enum ShipmentEndpoint {
  Base = '/shipments',
  Common = '/common',
  Enums = '/enums',
  Filters = '/filters',
  ReasonCodes = '/reason-codes',
  Shipment = '/shipment',
  Statistics = '/statistics',
  StatusCodes = '/status-codes',
  Exports = '/exports',
  Alerts = '/alerts',
  Loads = '/loads',
  Map = '/map',
  Tos = '/tos',
  Waybills = '/waybills',
  DeliveryNotes = '/delivery-notes',
  ContainerCharges = '/container-charges',
}
